import { render } from "./InboundPage.vue?vue&type=template&id=852caef6&ts=true"
import script from "./InboundPage.vue?vue&type=script&lang=ts"
export * from "./InboundPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__